import React, { useCallback, useMemo } from 'react';
import { Platform, View } from 'react-native';
import useAppNavigation from '~/hooks/useAppNavigation';
import Text from '../Text';
import Button from '../Button';
import type { SvgProps } from 'react-native-svg';
import colors from '~/assets/themes/colors';

export interface CardBenefitProps {
  type: 'health' | 'protection';
  data: Benefit;
}

export interface Benefit {
  icon: React.FC<SvgProps>;
  title: string;
  description?: string | React.ReactNode;
  detailsList?: string[] | React.ReactNode[];
  hasButton?: boolean;
}

const InsuranceCardBenefit: React.FC<CardBenefitProps> = ({ type, data }) => {
  const { navigate } = useAppNavigation();

  const onButtonPress = () => {
    navigate('MarisaServicos_MarisaTakesCareInsurance');
  };

  const typeProps = useMemo(() => {
    if (type === 'health') {
      return {
        iconColor: colors.health[600],
        iconBg: 'bg-health-200',
      };
    }

    return {
      iconColor: colors.protection[600],
      iconBg: 'bg-protection-200',
    };
  }, [type]);

  const RenderIcon = useCallback(() => {
    const { icon: Icon } = data;

    return <Icon color={typeProps.iconColor} width={24} height={24} />;
  }, [data, typeProps.iconColor]);

  return (
    <View
      className={`p-6 rounded-lg my-2 space-y-4 shadow bg-light-100 lg:flex-[0.33] lg:mr-4 lg:last:mr-0 lg:pb-[100px] ${
        Platform.OS === 'android' ? 'shadow-black/40' : ''
      }`}
    >
      <View className={`${typeProps.iconBg} p-4 rounded-full mr-auto`}>
        <RenderIcon />
      </View>

      <Text className="text-xl mt-4 text-gray-700">{data.title}</Text>

      <Text className="text-gray-400 text-sm">{data.description}</Text>

      {data.detailsList &&
        data.detailsList.map((detail, index) => (
          <View key={index} className="flex-row items-center">
            <Text className="mr-2 text-[4px] leading-5 text-gray-400 self-start">
              {'\u2B24'}
            </Text>
            <Text className="mr-2 text-sm text-gray-400">{detail}</Text>
          </View>
        ))}

      {data.hasButton && (
        <View className="flex-1 justify-end">
          <Button
            variant="secondary"
            className="py-2 px-4 rounded-[500px] mt-4 mr-auto"
            onPress={onButtonPress}
          >
            Saiba Mais
          </Button>
        </View>
      )}
    </View>
  );
};

export default InsuranceCardBenefit;
